import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { User, UserProfil, ProfileHierarchy } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private api: ApiService) {}

  getAllUsers(): Observable<User[]> {
    return this.api.get<User[]>('/labase/users');
  }

  getUserById(id: string): Observable<User> {
    return this.api.get<User>(`/labase/users/${id}`);
  }

  updateUser(id: string, data: Partial<User>): Observable<User> {
    return this.api.put<User>(`/labase/users/${id}`, data);
  }

  /**
   * Met à jour les profils d'un utilisateur
   */
  updateUserProfils(userId: string, profilIds: string[]): Observable<{ message: string; userId: string; profils: UserProfil[] }> {
    return this.api.put<{ message: string; userId: string; profils: UserProfil[] }>(
      `/labase/users/${userId}/profils`,
      { profilIds }
    );
  }

  /**
   * Récupère toutes les hiérarchies de profils
   */
  getProfileHierarchies(): Observable<ProfileHierarchy[]> {
    return this.api.get<ProfileHierarchy[]>('/auth/profile-hierarchies');
  }

  /**
   * Récupère tous les profils disponibles
   */
  getAllProfils(): Observable<UserProfil[]> {
    return this.api.get<UserProfil[]>('/auth/profils');
  }

  /**
   * Calcule la priorité maximale d'un utilisateur basée sur ses profils
   */
  getUserHighestPriority(user: User, hierarchies: ProfileHierarchy[]): number {
    if (!user.profils || user.profils.length === 0) return 0;

    let maxPriority = 0;
    for (const profil of user.profils) {
      const hierarchy = hierarchies.find(h => h.user_profil_id === profil.id || h.profil_code === profil.code);
      if (hierarchy && hierarchy.priority > maxPriority) {
        maxPriority = hierarchy.priority;
      }
    }
    return maxPriority;
  }

  /**
   * Vérifie si l'utilisateur courant peut modifier un utilisateur cible
   */
  canModifyUser(currentUser: User, targetUser: User, hierarchies: ProfileHierarchy[]): boolean {
    // On ne peut pas se modifier soi-même via cette fonction
    if (currentUser.id === targetUser.id) return false;

    const currentPriority = this.getUserHighestPriority(currentUser, hierarchies);
    const targetPriority = this.getUserHighestPriority(targetUser, hierarchies);

    // L'utilisateur courant doit avoir une priorité strictement supérieure
    return currentPriority > targetPriority;
  }
}
